<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OB8Zl5/image/Albert-Desert-Blues-lowres.jpg?1733067611476" alt="This image is the cover for the book Desert Blues"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Desert Blues
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An orphaned teenager moves in with his cocktail-waitress aunt in 1950s Palm Springs, in a novel with “its full share of hilarious, and touching, moments” (<i>Booklist</i>).</b><br/>  <br/> “Swinging from poignant drama to edgy satire to farce, Albert’s moving and funny first novel pairs an awkward orphaned adolescent immersed in 1950s rock ’n’ roll and an unconventional ‘kept’ woman. In 1957, confused, taciturn and fat 15-year-old Harold Abelstein, survivor of a car crash that killed his parents, goes to live with his Aunt Enid, a Palm Springs, Calif., cocktail waitress whose flowery perfumes, loud talk and constant pinching and touching make him uncomfortable. Enid’s rent and car are provided gratis by her part-time lover, incredibly self-absorbed Archie Blatt, a St. Louis garment manufacturer who pops in a few times a year to escape his invalid wife and teenage daughters. Though resenting her dependence, Enid faces a bigger problem when her manipulative, self-pitying father, Abe, who walked out on the family 25 years ago, suddenly reappears, shabby, reeking of whiskey and terminally ill. Tensions snap as Abe grows ever sicker and then Archie shows up, forcing four disparate souls to fitfully coexist under one roof. With a fine ear for dialogue, Albert perfectly captures a time and place—and the emotional chafing between family members who can't help but care for one another, despite themselves.” —<i>Publishers Weekly</i><br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Albert
      </h2>
      
      <p class="authorDescription body article">Bill Albert was born in New York and grew up in Southern California. He moved to England in 1964 and until recently taught history at the university in Norwich, where he still lives with his wife, his young daughter, and occasionally, their other four children. Besides writing, he is active in the disability movement. His first novel was DESERT BLUES.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ed6f378